/* @flow weak */

const React = require('react');
const _ = require('lodash');

import { VelocityComponent } from 'velocity-react';

const DetailSection = React.createClass({
  propTypes: {
    productData: React.PropTypes.object.isRequired
  },

  getInitialState() {
    return { activeTab: null }
  },

  description: undefined,
  shipping: undefined,
  details: undefined,

  componentWillMount() {
    const container = document.querySelector('.product.info.detailed.uc-container');
    let mage2Description;
    let mage2Details;
    let mage2Shipping;

    if (container) {
      mage2Description = _.get(container.querySelector('.product.attribute.description div.value'), 'innerHTML');
      mage2Details = _.get(container.querySelector('.additional-attributes-wrapper.table-wrapper'), 'innerHTML');
      mage2Shipping = _.get(container.querySelector('#shipping_description'), 'innerHTML');
      container.parentNode.removeChild(container);
    }

    const metadataDescription = _.get(this.props.productData, 'metadata.ProductDescription');
    const metadataShipping = _.get(this.props.productData, 'metadata.ProductShipping');
    const metadataDetails = _.get(this.props.productData, 'metadata.ProductDetails');

    this.description = mage2Description || metadataDescription;
    this.details = mage2Details || metadataDetails;
    this.shipping = mage2Shipping || metadataShipping;
  },

  componentDidMount() {
    if (this.description) {
      this.setState({ activeTab: 'description' });
    } else if (this.details) {
      this.setState({ activeTab: 'details' });
    } else if (this.shipping) {
      this.setState({ activeTab: 'shipping' });
    }
  },

  changeTab(tabName) {
    this.setState({
      activeTab: tabName === this.state.activeTab ? null : tabName
    });
  },

  renderTab(tabName, label, content) {
    return (
      <li className={`uc-${tabName}-tab ${this.state.activeTab === tabName ? 'uc-active' : ''}`} 
        onClick={this.changeTab.bind(null, tabName)}>
        <div className="uc-detail-tab-label">{label}</div>

        <div className="uc-detail-tab-content">
          <VelocityComponent component="div"
            animation={ this.state.activeTab === tabName ? 'slideDown' : 'slideUp' } 
            duration={300} 
            style={ this.state.activeTab === tabName ? {height: ''} : null }>
            <div dangerouslySetInnerHTML={{__html: content}} />
          </VelocityComponent>
        </div>
      </li>
    );
  },

  renderContent(tabName, content) {
    return (
      <div style={{ display: this.state.activeTab === tabName ? 'block' : 'none' }}>
        <div dangerouslySetInnerHTML={{__html: content}} />
      </div>
    );
  },

  render() {    
    let activeClass = (this.description || this.details || this.shipping) ? ' uc-active' : '';

    return (
      <div className={'uc-detail-section' + activeClass}>
        <div className="uc-detail-tabs">
          <ul>
            {this.description ? this.renderTab('description', 'Description', this.description) : null}
            {this.details ? this.renderTab('details', 'Details', this.details) : null}
            {this.shipping ? this.renderTab('shipping', 'Shipping', this.shipping) : null}
          </ul>
        </div>

        <div className="uc-detail-content">
          {this.description ? this.renderContent('description', this.description) : null}
          {this.details ? this.renderContent('details', this.details) : null}
          {this.shipping ? this.renderContent('shipping', this.shipping) : null}
        </div>
      </div>
    );
  }
});

module.exports = DetailSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/DetailSection.jsx